import script from "./MessageSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageSettings.vue?vue&type=script&setup=true&lang=js"

import "./MessageSettings.vue?vue&type=style&index=0&id=bcf6fb7a&lang=scss"

const __exports__ = script;

export default __exports__